import { axiosClient } from '@definitions/axios-client'
import { ProjectAvailableApiType, HitApiType, ProjectAchievementApiType } from '@api/types'
import { IListReqBody } from '@types'
import { AxiosResponse } from 'axios'
import { catchApiError } from '@utils'

export type GetProjectsPayloadType = IListReqBody & {
  model: {
    idProject?: string
  }
}
export const getProjects = async (
  payload: GetProjectsPayloadType,
): Promise<ProjectAvailableApiType[]> => {
  try {
    const axios = axiosClient()
    const resp = await axios.post<ProjectAvailableApiType[]>(
      `/TaskService/Hit/GetAvailableProjects`,
      payload,
    )
    return resp.data
  } catch (e) {
    catchApiError(e)
  }
}

export type GetProjectsAchievementPayloadType = IListReqBody & {
  model: {
    idProject?: string
  }
}
export const getProjectsAchievement = async (
  payload: GetProjectsAchievementPayloadType,
): Promise<ProjectAchievementApiType[]> => {
  try {
    const axios = axiosClient()
    const resp: AxiosResponse<ProjectAchievementApiType[]> = await axios.post(
      `/TaskService/Hit/GetAchievements`,
      payload,
    )
    return resp.data
  } catch (e) {
    catchApiError(e)
  }
}

export type GetHitsAchievementPayloadType = {
  idProject: string
  body: IListReqBody & {
    model: unknown
  }
}
export const getHitsAchievement = async (
  payload: GetHitsAchievementPayloadType,
): Promise<HitApiType[]> => {
  try {
    const axios = axiosClient()
    const resp: AxiosResponse<HitApiType[]> = await axios.post(
      `/TaskService/Hit/Achievements/Project/${payload.idProject}`,
      payload.body,
    )
    return resp.data
  } catch (e) {
    catchApiError(e)
  }
}
